import React, { Dispatch, SetStateAction } from 'react';

import {
  AttributesType,
  HydratedAttributeGroupsItem,
  InventoryAssetDetailType,
} from '@atom/types/inventory';

export type ErrorAttributes = {
  [attributeGroupId: string]: string[];
};

export enum AttributeView {
  SCHEMA_PREVIEW = 'SCHEMA_PREVIEW',
  MAP_TRAY = 'MAP_TRAY',
  ASSET_DETAIL = 'ASSET_DETAIL',
}

const NOOP = () => {};

interface Context {
  asset: InventoryAssetDetailType;
  loading: any[];
  attributeValueMap: {
    [key: string]: any;
  };
  onCancel: () => void;
  onAttributeChange: (attributeId: string, value: any) => void;
  editGroup: HydratedAttributeGroupsItem;
  setEditGroup: Dispatch<SetStateAction<HydratedAttributeGroupsItem>>;
  expanded: Set<any>;
  toggleExpanded: (groupId: string) => void;
  onSubmit: () => void;
  onPendingApproval: (
    action: string,
    attributeGroupName: string,
    attribute: AttributesType,
  ) => void;
  canManageChanges: boolean;
  canUpdate: boolean;
  splitView: boolean;
  errorAttributes: ErrorAttributes;
  setErrorAttributes: Dispatch<SetStateAction<ErrorAttributes>>;
  view: AttributeView;
  inputWidth: string;
}

export const initialState: Context = {
  asset: {},
  loading: [],
  attributeValueMap: null,
  onCancel: NOOP,
  onAttributeChange: NOOP,
  editGroup: null,
  setEditGroup: NOOP,
  expanded: new Set(),
  toggleExpanded: NOOP,
  onSubmit: NOOP,
  onPendingApproval: NOOP,
  canManageChanges: true,
  canUpdate: true,
  splitView: false,
  errorAttributes: {},
  setErrorAttributes: NOOP,
  view: AttributeView.ASSET_DETAIL,
  inputWidth: null,
};

const AttributeDetailsContext = React.createContext<Context>(initialState);

export default AttributeDetailsContext;
